/*!

=========================================================
* Paper Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { createBrowserHistory } from "history";
import { Router, Route } from "react-router-dom";
import CreateNewUser from "views/CreateNewUser.jsx";
import Login from "views/Login.jsx";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.1.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import ApplicantProfile from "views/ApplicantProfile";

const hist = createBrowserHistory();
const App = () => {
  return (
    <Router history={hist}>
      {/*<Route path="/applicant-profile" exact render={props => <ApplicantProfile {...props} />} />
      <Route exact path="/" render={props => <Login {...props} />} />*/}
      <Route path="/" render={props => <CreateNewUser {...props} />} />
    </Router>
  )
};



export default App;
